import { CampaignComments } from './Campaign.model';

export class TableReport {
  title: string = '';
  cols: string[] = [];
  rows: any[][] = [[]];
  comments: string = '';
  comentControl: keyof CampaignComments = 'general';
}
